export default "__VITE_ASSET__428e53b5__"